<script>
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button } from "view-design";
export default {
  extends: baseList,
  components: {
  },
  data() {
    return {
      table: {
        mname: "smsLog",
        key: "id",
        url: {
          list:"/admin/system/developLog/list",
          del: '/admin/system/developLog'
        },
        output: false,
        order:"createTime"
      },
      actions: [
        {
          label: "新增开发记录",
          icon: "md-add",
          onClick: this.toAdd,
          type: "info",
          auth: "admin/developmentlog/add",
        },
      ],

      filters: [
      ],
      tableCols: [
        {
          title: "序号",
          key: "id",
          width: 80,
          align: "center",
          render: (h, params) => {
            return h(
              "span",
              params.index + (params.row.pageNum - 1) * params.row.pageSize + 1
            );
          },
        },
        {
          title: "更新内容",
          key: "content",
          minWidth: 250,
          align: "center",
        },
        {
          title: "版本号",
          key: "version",
          minWidth: 120,
          align: "center",
        },
        {
          title: "创建时间",
          width: 150,
          align: "center",
          key: "updateTime",
          render: (h, params) => {
            const row = params.row;
            const text = row.updateTime||row.createTime
            const text2 = text.slice(0, 16)
            return (
              <span style={{ "font-size": "14px" }}>{text2}</span>
            );
          },
        },
        {
          title: "操作",
          align: "center",
          width: 160,
          key: "handle",
          handle: ["edit", "delete"],
          auth:{
            edit:"admin/developmentlog/edit",
            del:"admin/developmentlog/delete",
          } 
        },
      ],
    };
  },
  created() {
  },
  methods: {
    toAdd() {
      $utils.url.push({ name: "developmentlog_add", query: { action: "add" } });
    },
     handleEdit(currentRow){
      $utils.url.push({ name: "developmentlog_edit", query: {action: "edit",kv:currentRow.id } });
    },
    //转单
    // toChange(row) {},
    //详情
    // toInfo(row) {
    //   $utils.url.push({
    //     name: 'knowledgeBase_info',
    //     query: { action: 'edit', kv: row.id },
    //   })
    // },
  },
};
</script>
<style scoped></style>
